function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import i18n from '@pureartisan/simple-i18n';
import { IoMdShare } from 'react-icons/io';
import clsx from 'clsx';
import useStore from './../store';
import { CoreButton } from './../../../core';

var UnifiedShareBtn = function UnifiedShareBtn(_ref) {
  var props = _extends({}, _ref); // Generic store value setter.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  });
  var shareHash = useStore(function (state) {
    return state.shareHash;
  });
  var buttonTooltipPosition = useStore(function (state) {
    return state.buttonTooltipPosition;
  });
  var unifiedShareModal = useStore(function (state) {
    return state.unifiedShareModal;
  });

  var handleShare = function handleShare() {
    setStoreValues({
      unifiedShareModal: !unifiedShareModal
    });
  };

  return /*#__PURE__*/React.createElement(CoreButton, {
    id: "button_u_share_link",
    label: i18n.translate("BUTTON_SHARE_UNIFIED"),
    tooltip: buttonTooltipPosition,
    onClick: handleShare,
    color: "none",
    className: clsx(props.className, 'button-u-share-link button-share')
  }, /*#__PURE__*/React.createElement(IoMdShare, null), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, i18n.translate("BUTTON_SHARE_UNIFIED")));
};

export default UnifiedShareBtn;